export { NAMES_SEARCH } from './namesSearch';
export { ADVANCED_NAMES_SEARCH } from './advancedNamesSearch';

export enum ESearchType {
  AUTOCOMPLETE = 'AUTOCOMPLETE',
  FULL_SEARCH = 'FULL_SEARCH',
  FUZZY_DUPLICATES = 'FUZZY_DUPLICATES',
}

export enum EFileExportType {
  CSV = 'CSV',
  XLS = 'XLS'
}